import { create } from "zustand";
import {
    saveOrder,
    type SaveOrderPayload,
} from "@/models/order/hooks/saveOrder";

type OrderState = {
    isSubmitting: boolean;
    isSuccess: boolean;
    error: string | null;
    signature: string;
    signatureUrl: string;
    hasPreviousOrder: boolean;
    isMeasurementSigned: boolean;
    orderId: string;
};

export type SubmitResult = { orderId: string } | null;

type OrderActions = {
    submit: (payload: SaveOrderPayload) => Promise<SubmitResult>;
    resetForSignaturePage: () => void;
    setSignature: (sig: string) => void;
    setSignatureUrl: (url: string) => void;
    setHasPreviousOrder: (v: boolean) => void;
    setIsMeasurementSigned: (v: boolean) => void;
    setOrderId: (id: string) => void;
};

export const useOrderStore = create<OrderState & OrderActions>()((set) => ({
    isSubmitting: false,
    isSuccess: false,
    error: null,
    signature: "",
    signatureUrl: "",
    hasPreviousOrder: false,
    isMeasurementSigned: false,
    orderId: "",
    resetForSignaturePage: () =>
        set({ isSuccess: false, signature: "", signatureUrl: "", error: null }),
    setSignature: (sig) => set({ signature: sig }),
    setSignatureUrl: (url) => set({ signatureUrl: url }),
    setHasPreviousOrder: (v) => set({ hasPreviousOrder: v }),
    setIsMeasurementSigned: (v) => set({ isMeasurementSigned: v }),
    setOrderId: (id) => set({ orderId: id }),
    submit: async (payload) => {
        set({ isSubmitting: true, error: null });
        try {
            const { orderId, signatureUrl } = await saveOrder(payload);
            set((state) => ({
                isSubmitting: false,
                isSuccess: true,
                orderId,
                signatureUrl: signatureUrl || state.signatureUrl,
                signature: payload.signatureDataUrl ?? state.signature,
            }));
            return { orderId };
        } catch {
            set({ isSubmitting: false, error: "confirmStep.submitError" });
            return null;
        }
    },
}));
